module.exports = __webpack_public_path__ + "img/diners_white.66e260f1.svg";